<template>
  <div>
    <div class="section" v-if="isMemberEnterpriseTeam === false">
      <div class="name">{{ this.model.name }}</div>
    </div>
    <div class="section1" v-if="isMemberEnterpriseTeam === true">
      <div class="name">{{ this.model.name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["model", "isMemberEnterpriseTeam"],
  components: {},
  data() {
    return {
    };
  },
  computed: {},
  mounted() {},
  watch: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-image: url("~@/views/CNBM/images/Cover.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: 1124px; //A4纸的高度像素
  overflow: hidden;
  padding-top: 130px;
}
.section1 {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-image: url("~@/views/CNBM/images/MemberEnterpriseTeamCover.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: 1124px; //A4纸的高度像素
  overflow: hidden;
  padding-top: 130px;
}
.name {
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #4a4a4a;
  margin-left: 242px;
  margin-top: 805px;
}
</style>




// WEBPACK FOOTER //
// src/views/CNBMTalent/pages/cover.vue